// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"24":"959af9cd142514db","722":"f33aa94de6ae126a","858":"8f46591f9b105e2c"}[chunkId] + ".esm.js";
};